export class Populations {
  public static Hospitality = 'Hospitality';
  public static Membership = 'Membership/STH';
  public static International = 'International';
  public static Free = 'Free';
  public static JuniorBluebirds = 'Kids';
}
